<template>
  <div
    class="modal fade"
    id="videoModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content rounded-0">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Our Recent Project</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="ratio ratio-16x9">
            <iframe
              class="embed-responsive-item"
              :src="videoSrc"
              id="video"
              allowfullscreen
              allowscriptaccess="always"
              allow="autoplay"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue'

declare global {
  interface Window {
    bootstrap: any
  }
}

export default defineComponent({
  name: 'VideoModalView',
  setup () {
    const videoSrc = ref('')
    let modalInstance: any = null

    onMounted(() => {
      const modalElement = document.getElementById('videoModal')
      if (modalElement && window.bootstrap) {
        modalInstance = new window.bootstrap.Modal(modalElement)

        // Handle play button clicks
        document.addEventListener('click', (e) => {
          const target = e.target as HTMLElement
          const playButton = target.closest('.btn-play')
          if (playButton) {
            const src = (playButton as HTMLElement).getAttribute('data-src')
            if (src) {
              videoSrc.value = src + '?autoplay=1&modestbranding=1&showinfo=0'
              modalInstance?.show()
            }
          }
        })

        // Clear video when modal is hidden
        modalElement.addEventListener('hidden.bs.modal', () => {
          videoSrc.value = ''
        })
      }
    })

    return {
      videoSrc
    }
  }
})
</script>
